var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('top'),_c('lbt'),_c('bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }